// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"dc511cf7","193":"eade3576"}[chunkId] + ".chunk.js";
};